/**
 * The exam-player routes render outside the app shell and must never be
 * covered by global chrome — no tab bar, no toasts, no banners — because a
 * timed sitting has its own save indicator and nothing may distract from it.
 *
 * Phase 189 added the read-only paper review. It is not a sitting, but it
 * wears the exam's chrome (the near-black bar, the split panes, the fixed
 * question strip), so app furniture floating over it would be just as wrong.
 */
export const EXAM_ROUTE_PATTERN =
  /^\/student\/(?:exam|practice)\/|^\/student\/results\/[^/]+\/paper\/?$/;

export function isExamRoute(pathname: string): boolean {
  return EXAM_ROUTE_PATTERN.test(pathname);
}
